<template>
  <div>  
    <b-modal ref="modal" size="lg" header-bg-variant="primary" top footer-class="pb-2 justify-content-end border-0">
        <template #modal-header="" >
            <h3 style="color: white;margin: 0">Migrate Existing Companies To Enston Secretary</h3>
        </template>

        <template>
            <slot name="body">
                <validation-observer ref="migrateExistingCompany">
                    <validation-provider
                        v-slot="{ errors }"
                        name="company name"
                        rules="required"
                    >
                        <b-form-group label="Company name" label-for="company-name">
                            <b-form-input
                                id="company-name"
                                v-model="company.companyName"
                                trim
                                :state="errors.length > 0 ? false : null"
                                placeholder="Enter company name"
                                data-test ="company-name"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                    </validation-provider>

                    <validation-provider
                        v-slot="{ errors }"
                        name="share drive"
                        rules="required"
                        class="end-align-indicator-long-select"
                    >
                        <b-form-group label="Share drive" :state="errors.length > 0 ? false : null">
                            <v-select
                                ref="shareDriveFolder"
                                v-model="company.shareDriveFolder"
                                class="custom-select-icon share-drive"
                                :clearable="false"
                                placeholder="Select share drive folder"
                                value="id"
                                label="name"
                                :options="shareDriveFolderOptions"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                            </b-form-group>
                        </validation-provider>

                        <validation-provider
                            v-slot="{ errors }"
                            name="secretary folder id"
                            rules="required"
                        >
                            <b-form-group>
                                <slot name="label">
                                    <label id="company-folder-id" for="company-folder-id">
                                        Company folder ID
                                        <vector
                                            data-type="icon"
                                            data-width="14px"
                                            data-height="14px"
                                            data-class="mr-.5"
                                            data-name="information"
                                            style="position:relative; bottom:1px;"
                                        ></vector>
                                    </label>
                                </slot>

                                <b-popover
                                    target="company-folder-id"
                                    triggers="hover"
                                    placement="right"
                                    variant="black"
                                >
                                    Please provide the company folder ID from the drive of the company you are migrating.
                                </b-popover>

                                <b-form-input
                                    ref="renewalFee"
                                    v-model="company.companyFolderId"
                                    class="dont-capitalize"
                                    placeholder="Enter company folder ID"
                                    :state="errors.length > 0 ? false : null"
                                    data-test="company-folder-id"
                                />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </b-form-group>

                            <!-- check all or only active records -->
                            <div class="switch-check mt-2 mb-2">
                                <b-form-checkbox 
                                    v-model="company.migrateFormat" 
                                    :value="migrateActiveOnly" 
                                    :unchecked-value="migrateAll"
                                    switch
                                    size="md"
                                > 
                                   Only active records 
                                </b-form-checkbox>
                            </div>
                        </validation-provider>
                </validation-observer>
            </slot>
        </template>

        <template #modal-footer="{ cancel }">
            <slot name="footer" class="justify-content-end">
                <b-button :disabled="isProcessingMigration" size="lg" class="mr-1 d-flex align-items-center" variant="primary" @click="migrate">
                    Migrate
                    <vector
                        v-if="! isProcessingMigration"
                        data-type="icons" 
                        data-width="15px"
                        data-height="15px"
                        data-name="transfer" 
                        style="padding-left: 5px"
                        alt="migrate-company-logo"
                    />
                    <normal-loader v-else style="position:relative; left:18px; padding:1px 5px;" />
                </b-button>

                <b-button size="lg" class="ml-1 d-flex align-items-center" variant="outline-danger" @click="cancel()">
                    Cancel
                    <vector 
                        data-type="icons" 
                        data-width="15px" 
                        data-height="15px" 
                        data-name="cancel" 
                        class="float-right ml-.5"
                        alt="cancel-logo"
                    />
                </b-button>
            </slot>
        </template>
    </b-modal>
  </div>
</template>

<script>
import { BModal, BButton, BFormGroup, BFormInput, BPopover, BFormCheckbox } from 'bootstrap-vue';
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import ShareDrive from '@/models/ShareDrive';
import { COMPANY } from "@/constants/config";

export default {
    components:{
        BModal,
        BButton,
        BFormGroup,
        BFormInput,
        BPopover,
        BFormCheckbox,

        vSelect,

        ValidationProvider,
        ValidationObserver,
    },

    props: {
        isProcessingMigration: {
            type: Boolean,
            required: true,
        }
    },

    data() {
        return {
            required, 
            migrateActiveOnly: COMPANY.MIGRATION_FORMAT.ACTIVE_ONLY,
            migrateAll: COMPANY.MIGRATION_FORMAT.ALL,

            company : {
                companyName: undefined,
                shareDriveFolder: undefined,
                companyFolderId: undefined,
                migrateFormat: COMPANY.MIGRATION_FORMAT.ALL,
            },
            shareDriveFolderOptions: [],
        };
    },

    async created() {
        this.shareDriveFolderOptions = await ShareDrive.all();
    },

    methods: {
        migrate() {
            this.$refs.migrateExistingCompany.validate().then(success => {
                if (success) {
                    this.$emit('migrateExistingCompany', this.company);
                }
            });
        },

        clearForm() {
            this.$refs.migrateExistingCompany.reset();
            Object.keys(this.company).forEach(key => {
                if(key === 'migrateFormat') {
                    this.company.migrateFormat = COMPANY.MIGRATION_FORMAT.ALL;
                } else {
                    this.company[key] = undefined;
                }
            });
        }
    }
};

</script>
